import React from "react";
const ContactUs = React.lazy(() => import("./pages/ContactUs"));
const FourZeroFour = React.lazy(() => import("./pages/FourZeroFour"));
const FourZeroThree = React.lazy(() => import("./pages/FourZeroThree"));
const Home = React.lazy(() => import("./pages/Home"));
const LandingPage = React.lazy(() => import("./pages/LandingPage"));
const Login = React.lazy(() => import("./pages/Login"));
const Logout = React.lazy(() => import("./pages/Logout"));
const LostPassword = React.lazy(() => import("./pages/LostPassword"));
const Paynow = React.lazy(() => import("./pages/Paynow"));
const Product = React.lazy(() => import("./pages/Product"));
const Profile = React.lazy(() => import("./pages/Profile"));
const Register = React.lazy(() => import("./pages/Register"));
const ResetPassword = React.lazy(() => import("./pages/ResetPassword"));
//import ShowOrders from './pages/showOrders';
const ShowOrders = React.lazy(() => import("./pages/showOrders"));
export const routes = [
  {
    isPvt: 0,
    path: "/product/:id",
    name: "product",
    component: <Product />,
  },
  {
    isPvt: 0,
    path: "/product/:id/:mode",
    name: "product",
    component: <Product />,
  },
  {
    isPvt: 0,
    path: "/",
    name: "landingPage",
    component: <LandingPage />,
  },
  {
    isPvt: 0,
    path: "/lost-password",
    name: "lost password",
    component: <LostPassword />,
  },
  {
    isPvt: 0,
    path: "/reset-password/:userId/:rtoken",
    name: "lost password",
    component: <ResetPassword />,
  },
  {
    isPvt: 0,
    path: "/login",
    name: "Login",
    component: <Login />,
  },
  {
    isPvt: 0,
    path: "/login/:msg",
    name: "Login",
    component: <Login />,
  },
  {
    isPvt: 0,
    path: "/logout",
    name: "Logout",
    component: <Logout />,
  },

  {
    isPvt: 0,
    path: "/register",
    name: "register",
    component: <Register />,
  },
  {
    isPvt: 1,
    path: "/profile/",
    name: "profile",
    component: <Profile />,
  },
  {
    isPvt: 1,
    path: "/order/",
    name: "order",
    component: <ShowOrders />,
  },
  {
    isPvt: 1,
    path: "/contactus/",
    name: "contact Us",
    component: <ContactUs />,
  },
  {
    isPvt: 1,
    path: "/payment/:renewal",
    name: "profile",
    component: <Paynow />,
  },
  {
    isPvt: 1,
    path: "/paynow/",
    name: "profile",
    component: <Paynow />,
  },
  {
    isPvt: 1,
    path: "/dashboard",
    name: "dashboard",
    component: <Home />,
  },
  {
    isPvt: 1,
    path: "/home",
    name: "home",
    component: <Home />,
  },
  {
    isPvt: 0,
    path: "/403",
    name: "403",
    component: <FourZeroThree />,
  },
  {
    isPvt: 0,
    path: "*",
    name: "404",
    component: <FourZeroFour />,
  },
];
